import { Dispatch, SetStateAction, useContext } from 'react';
import { ChevronDown } from '@styled-icons/feather';
import classNames from 'classnames';
import styles from '../../SideToolbar.module.css';
import { DropdownContext } from '../../../../components/Dropdown';

function ToolbarCustomAttributesInput({
  customKeyOpen, setCustomKeyOpen, selectedAttribute, setSelectedAttribute,
}: {
  customKeyOpen: boolean;
  setCustomKeyOpen: Dispatch<SetStateAction<boolean>>;
  selectedAttribute: string;
  setSelectedAttribute: Dispatch<SetStateAction<string>>;
}) {
  const { setIsDropdownOpen } = useContext(DropdownContext);

  return (
    <div
      className="p-3"
      role="none"
      data-testid="Toolbar_attributes_custom"
    >
      <div role="none" onClick={() => setCustomKeyOpen(!customKeyOpen)}>
        <span className="tag" style={{ backgroundColor: 'transparent' }}>
          Custom
        </span>
        <ChevronDown size={10} />
      </div>
      { !!customKeyOpen && (
        <input
          className={classNames(styles.menuItem, styles.flex1)}
          value={selectedAttribute}
          type="text"
          placeholder="Insert key"
          data-testid="Toolbar_InsertLink_Input"
          onChange={(e) => { setSelectedAttribute(e.target.value); }}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              setIsDropdownOpen(false);
            }
          }}
        />
      )}
    </div>
  );
}
export default ToolbarCustomAttributesInput;
